import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { ROLES } from '../../utils/roles.enums';
import Swal from 'sweetalert2';

@Injectable({
	providedIn: 'root'
})
export class RoleGuard implements CanActivate {
	constructor(
		private _authService: AuthenticationService,
		private _router: Router
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const allowedRoles = route.data['allowedRoles'] as Array<ROLES>;
		const userRole = this._authService.userRole;

		if (!allowedRoles || allowedRoles.length === 0) {
			return true;
		}

		if (allowedRoles.includes(userRole)) {
			return true;
		}

		// Si el usuario no tiene el rol permitido
		Swal.fire({
			title: 'Acceso Denegado',
			text: 'No tienes permisos suficientes para acceder a esta sección.',
			icon: 'error',
			confirmButtonColor: 'var(--ui-primary)',
			heightAuto: false,
		});

		this._router.navigate(['/home']);
		return false;
	}
}
